import React from "react";
import { Container, Segment, Dropdown } from "semantic-ui-react";
import BaseTable from "../../components/BaseTable";
import ACL_RELATIONSHIPS from "../../acl-relationships";
import withRoleCheck from "../../components/hocs/withRoleCheck";
import AuthService from "../../services/Auth";
import CustomDropdown from "../../components/CustomDropdown";
import setPageTitle from "../../helpers/title";
import RevenueOpportunityStatusPresetService from "../../services/RevenueOpportunityStatusPreset";
import _DeleteRevenueOpportunityStatusPresetModal from "./components/DeleteRevenueOpportunityStatusPresetModal";
import RevenueOpportunityStatusPresetModal from "./components/RevenueOpportunityStatusPresetModal";

const NewRevenueOpportunityStatusPresetModal = withRoleCheck(
  RevenueOpportunityStatusPresetModal,
  [
    ACL_RELATIONSHIPS.revenueOpportunityStatusPreset.create,
    ACL_RELATIONSHIPS.revenueOpportunityStatus.read,
  ]
);

const EditRevenueOpportunityStatusPresetModal = withRoleCheck(
  RevenueOpportunityStatusPresetModal,
  [
    ACL_RELATIONSHIPS.revenueOpportunityStatusPreset.edit,
    ACL_RELATIONSHIPS.revenueOpportunityStatus.read,
  ]
);

const DeleteRevenueOpportunityStatusPresetModal = withRoleCheck(
  _DeleteRevenueOpportunityStatusPresetModal,
  [ACL_RELATIONSHIPS.revenueOpportunityStatusPreset.delete]
);

class RevenueOpportunityStatusPresetsTable extends BaseTable {
  constructor(props) {
    super(props);

    this.queryMethod =
      RevenueOpportunityStatusPresetService.getRevenueOpportunityStatusPresetsAsTable;

    this.state = {
      ...this.state,
      header: "Revenue Opportunity Presets",
      headerIcon: "bullseye",
      tableName: "revenue_opportunity_status_presets",
      noDataText: "No presets found. Try adjusting your filters.",
      createButton: (
        <NewRevenueOpportunityStatusPresetModal fetchPresets={this.fetchData} />
      ),
    };
  }

  async componentDidMount() {
    setPageTitle("Revenue Opportunity Presets");
    if (AuthService.isLoggedIn()) {
      this.fetchData();
    }
  }

  setColumns = () => {
    const columns = [
      {
        Header: "ID",
        accessor: "id",
        width: 50,
      },
      {
        Header: "Name",
        accessor: "name",
        width: 250,
      },
      {
        Header: "Revenue Opportunity Statuses",
        accessor: "info.revenue_opportunity_statuses",
        sortable: false,
        Cell: ({ value }) =>
          value && value.length > 0
            ? value.map(({ name }) => name).join(", ")
            : "--",
      },
      {
        Header: "Actions",
        id: "actions",
        headerClassName: "action-menu non-sortable",
        className: "action-menu",
        sortable: false,
        Cell: ({ original: preset }) => (
          <CustomDropdown icon="ellipsis horizontal">
            <Dropdown.Menu direction="left">
              <EditRevenueOpportunityStatusPresetModal
                preset={preset}
                fetchPresets={this.fetchData}
              />
              <DeleteRevenueOpportunityStatusPresetModal
                preset={preset}
                fetchPresets={this.fetchData}
              />
            </Dropdown.Menu>
          </CustomDropdown>
        ),
      },
    ];
    this.initTableSettings(columns);
  };

  render() {
    return (
      <Container fluid className="route sub-route">
        <div className="campaign-segment">
          <Segment>{this.renderTable()}</Segment>
        </div>
      </Container>
    );
  }
}

export default RevenueOpportunityStatusPresetsTable;
